import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { BoxArrowRight, Person } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../store/user/UserSlice";
import logo from "../logo.svg";

const Sidebar = ({ sidebarOpen, title, children }) => {
  const { user } = useSelector((state) => state.user || {});
  const navigate = useNavigate();

  const dispatch = useDispatch();
  return (
    <Col
      md={2}
      className={`min-vh-100 max-vh-100 p-0 sidebar ${
        sidebarOpen ? "show" : ""
      }`}
    >
      <Link to={"/"} className="navbar-brand">
        <img src={logo} alt="Logo" />
      </Link>
      <div className="sidebar_class">
        {/* <h5 className="mb-4">{title}</h5> */}
        <ul className="nav flex-column">{children}</ul>
      </div>
      <div className="current_user">
        <Row>
          <div className="col-md-4 user_profile">
            <Person />{" "}
          </div>

          <div className="col-md-8 user_details">
            <p>{user?.email}</p>
          </div>
        </Row>
        <Row>
          <Button
            variant="warning"
            onClick={() => {
              dispatch(logout());
              navigate("/");
            }}
          >
            <BoxArrowRight /> Sign Out
          </Button>
        </Row>
      </div>
    </Col>
  );
};

export default Sidebar;
